<template>
  <div class="plan-task-item">
    <div class="title">
      <div class="icon-box">
        <span>任务{{ task.taskDay }}</span>
        <img src="@/assets/images/transh-del.svg" class="delete-icon cursor-pointer" alt="" @click="deleteTask">
      </div>
      <span @click="isOpen = !isOpen"><i class="el-icon-arrow-up cursor-pointer" :class="{'rotate-icon': !isOpen}" /></span>
    </div>
    <div v-if="isOpen" class="content">
      <div class="content-theme">
        <span class="theme-txt"> <span class="required-point">*</span> 任务主题</span>
        <el-form :model="task" :rules="rules">
          <el-form-item prop="campTopic">
            <el-input v-model="task.campTopic" :disabled="disabled" style="width: 360px;" maxlength="12" placeholder="请输入任务主题，最多不超过12个字" />
          </el-form-item>
        </el-form>
      </div>
      <div class="content-items">
        <template v-for="(item,index) in task.content">
          <UploadImage :key="index" :image-url="item.taskImage || ''" :img-info="imgInfo" :custom-style="customStyle" :course-name="item.taskName" :item="item" required :disabled="disabled" @deleteCourse="deleteCourse" @uploadImgChange="uploadImgChange" />
        </template>
        <el-button type="primary" class="add-course-btn" :disabled="disabled" @click="addCourse">添加课程</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import UploadImage from './uploadImage.vue';

export default {
  name: 'PlanTask',
  components: { UploadImage },
  props: {
    task: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imgInfo: { name: '任务列表页封面', size: 5, width: 670, height: 335, key: 'taskImage' },
      customStyle: { width: '180px', height: '154px' },
      isOpen: true,
      courseName: '',
      rules: {
        campTopic: [
          { required: true, message: "请输入任务主题", trigger: ["blur"] },
        ],
      },
    };
  },
  methods: {
    deleteTask() {
      if (this.disabled) return;
      this.$emit('deleteTask', this.task.taskDayIndex);
    },
    addCourse() {
      this.$emit('addCourse', this.task.taskDayIndex);
    },
    uploadImgChange(data) {
      this.task.content = this.task.content.map(item => {
        if (item.taskId === data.item.taskId) {
          item.taskImage = data.url;
        }
        return item;
      });
    },
    deleteCourse(element) {
      this.$emit('deleteCourse', element);
    },
  },
};
</script>

<style lang="less" scoped>
.cursor-pointer{
  cursor: pointer;
  transition: all 0.5s;
}
.title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  font-size: 14px;
  font-weight: 700;
  color: #494949;
  border-bottom: 1px solid #e1e1e1;
  .icon-box{
    display: flex;
    align-items: center;
    .delete-icon{
      width: 16px;
      height: 16px;
    }
  }
}
.rotate-icon{
  transform: rotate(180deg);
}
.content{
  transition: all 0.5s;
  .content-theme{
    display: flex;
    align-items: center;
    width: 100%;
    gap: 10px;
    margin-top: 30px;
    .theme-txt{
      color: #494949;
      font-size: 14px;
    }
    .required-point{
      color: #ff4d4f;
    }
  }
  .content-items{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 80px;
    width: 100%;
    min-height: 264px;
    margin-top: 30px;
  }
  .add-course-btn{
    width: 94px;
    height: 38px;
    align-self: center;
    margin-left: -50px;
  }
  .add-course-btn:first-child{
    margin-left: 0;
  }
}

</style>
